import React from 'react';
import { useIntl } from 'react-intl';

import { useStateFromProp } from '~hooks/common';

import Modal from '~components/modal';

const ReviewModal = ({ isOpened, onToggle = () => {} }) => {
  const intl = useIntl();
  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={() => setModalOpen()} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {intl.formatMessage({
            id: 'containers.review.modal.headline',
            defaultMessage: 'Stars rating overview',
          })}
        </h2>
        <p>
          {intl.formatMessage({
            id: 'containers.review.modal.description',
            defaultMessage: 'To guide you with selecting the right amount of stars,here is a little overview:',
          })}
        </p>
        <p className="l-small-text">
          {intl.formatMessage({
            id: 'containers.review.modal.one-star',
            defaultMessage: '1 star: not satisfied*',
          })}
        </p>
        <p className="l-small-text">
          {intl.formatMessage({
            id: 'containers.review.modal.two-stars',
            defaultMessage: '2 stars: not sufficient, needs improvement*',
          })}
        </p>
        <p className="l-small-text">
          {intl.formatMessage({
            id: 'containers.review.modal.three-stars',
            defaultMessage: '3 stars: sufficient',
          })}
        </p>
        <p className="l-small-text">
          {intl.formatMessage({
            id: 'containers.review.modal.four-stars',
            defaultMessage: '4 stars: good',
          })}
        </p>
        <p className="l-small-text">
          {intl.formatMessage({
            id: 'containers.review.modal.five-stars',
            defaultMessage: '5 stars: excellent',
          })}
        </p>
      </Modal.Content>
    </Modal.Wrapper>
  );
};

export default ReviewModal;
